import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from '@la/ds-ui-components';
import * as S from './DivisionCardFooter.styles';
export function DivisionCardFooter({ onCancel, onSave, shouldUpdateFields, }) {
    return (_jsxs(S.DivisionCardFooter, { children: [_jsx(S.DivisionCardCancelButton, Object.assign({ variant: "text", size: "medium", onClick: onCancel }, { children: "Cancel" })), _jsx(Button, Object.assign({ variant: "primary", size: "medium", onClick: onSave }, { children: shouldUpdateFields ? 'Update and save' : 'Save division' }))] }));
}
